/*
 * Copyright (c) 2022-2024 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */
import { z } from 'zod'

export const Role = z.object({ organizationId: z.string().nullish(), projectId: z.string().nullish(), roleId: z.string() })

export interface Role extends z.TypeOf<typeof Role> {}
